import React from "react";
import { useTheme } from "../context/ThemeContext";

// Import Phosphor icons
import { List, ChartBar, SlidersHorizontal, Play, DotsNine } from "@phosphor-icons/react";

function Divider() {
    const { theme } = useTheme();

    const styles = {
        divider: {
            // position: "absolute", 
            // bottom: 0, 
            width: "100%", 
            height: "1px", 
            backgroundColor: theme.colors.fillSecondary,
        }
    }
  
  return (
    <div className="header-divider" style={{padding: "0 16px"}}>
       <div style={styles.divider}></div>
    </div>
  );
}

export default Divider;